export default "__VITE_ASSET__Dfos0x61__"